/* eslint-disable react-hooks/exhaustive-deps */
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import ReactCookies from 'react-cookies';
import { useDispatch, useSelector } from 'react-redux';
import { COOKIES, LOCATION_SELECTED } from '../../brands/default/constants';
import { HEADER_LOCATION } from '../../brands/default/content/components/header';
import { makeUrlAbsolute, redirectToURL } from '../../helpers/url';
import { setLocation } from '../../redux/actions/locations';
import { getNavigation } from '../../redux/actions/navigation';
import WowModal from '../WowModal';
import HeaderIcon from './HeaderIcon';
import HeaderLocationList from './HeaderLocationList';

const HeaderLocation = ({ countryCode }) => {
  const [locations, location] = useSelector((state) => [
    state.locations.locations,
    state.locations.location,
  ]);
  const hasSelection =
    typeof window === 'undefined'
      ? {}
      : localStorage.getItem(LOCATION_SELECTED);
  const lightboxLocation = ReactCookies.load(COOKIES.lightboxLocation);

  const locationObject = location || lightboxLocation;
  const locationName = locationObject?.shortName;
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const router = useRouter();

  const onClickIcon = (show) => {
    setShowModal(show);
  };
  useEffect(() => {
    if (lightboxLocation && hasSelection !== 'set') {
      dispatch(setLocation(locationObject, true));
    }
  }, [locationName]);

  const onSelectLocation = (locationToSet) => {
    dispatch(setLocation(locationToSet, true));

    dispatch(getNavigation(locationToSet));
    if (typeof window !== 'undefined') {
      const url = makeUrlAbsolute(`deals/${locationToSet.shortName}`);
      window.location.href = url;
      redirectToURL(url, router);
      localStorage.setItem(LOCATION_SELECTED, 'set');
    }
    setShowModal(false);
  };

  return (
    <>
      <WowModal
        ariaLabelledBy="id-choose-loc"
        backdropClassName="remove-backdrop"
        extraClasses="fullscreen-mobile remove-header with-fade-in no-body-padding"
        setShowModal={setShowModal}
        showModal={showModal}
        size="lg"
      >
        <HeaderLocationList
          countryCode={countryCode}
          locations={locations}
          onCancel={() => setShowModal(false)}
          onSelectLocation={onSelectLocation}
          selection={locationObject}
        />
      </WowModal>

      <HeaderIcon
        aria-label={HEADER_LOCATION.changeLocation}
        clickMethod={() => onClickIcon(true)}
        extraClasses="with-fade-in"
        icon="location"
        isFirst
        linkId="id-choose-loc"
      />
    </>
  );
};

HeaderLocation.propTypes = {
  countryCode: PropTypes.string,
};

export default HeaderLocation;
